import React from "react";
import ChecklistActions from "../onboarding/ChecklistActions";
import GoogleHoursAudit from "./GoogleHoursAudit";
import HoursOfOperationTableRow from "./HoursOfOperationTableRow";
import { pulseElement } from "../operations_assistant/helpNavigation";

export const hoursStoreRowId = (storeId) => `hours-store-${storeId}`;

function HoursOfOperationDisplay(props) {
  const [checkingHours, setCheckingHours] = React.useState(false);
  const verification = props.canCheckPublishedHours && <>
    <div className="flex justify-end">
      <ChecklistActions title="operating hours" options={[{ label: checkingHours ? "Close published hours check" : "Check published hours" }]}
        onOption={() => setCheckingHours(value => !value)} />
    </div>
    {checkingHours && <GoogleHoursAudit locations={props.hoursOfOperation || []} onSaved={props.onHoursVerified} />}
  </>;
  // Setup Assistant follow-along: bring the location under review into
  // view. The row's editor stays closed; hours land through Lumi's card.
  const focusStoreId = props.focusStore?.storeId;
  const focusAt = props.focusStore?.at;
  const hasRow = Boolean(
    focusStoreId && props.hoursOfOperation?.some((loc) => Number(loc.storeId) === Number(focusStoreId))
  );
  // One pulse per focus request, even if the hours list refetches later.
  const handledFocusRef = React.useRef(null);
  React.useEffect(() => {
    if (!hasRow || handledFocusRef.current === focusAt) return;
    handledFocusRef.current = focusAt;
    const frame = window.requestAnimationFrame(() => {
      const el = document.getElementById(hoursStoreRowId(focusStoreId));
      if (el) pulseElement(el);
    });
    return () => window.cancelAnimationFrame(frame);
  }, [focusStoreId, focusAt, hasRow]);

  if (props.embedded) {
    return <div className="space-y-4">
      {verification}
      {props.hoursOfOperation?.map((location) => (
        <HoursOfOperationTableRow
          key={location.storeId}
          embedded
          canCheckPublishedHours={props.canCheckPublishedHours}
          onHoursVerified={props.onHoursVerified}
          isSavingData={props.isSavingData}
          location={location}
          update_hours_for_all_stores={props.update_hours_for_all_stores}
          storeNames={props.storeNames}
        />
      ))}
    </div>;
  }

  return (
    <div>
      {verification}
      {/* <SettingsHeader title="Hours of Operations" /> */}
      <div className={props.embedded ? "flex flex-col" : "mt-8 flex flex-col"}>
        <div className={props.embedded ? "overflow-x-auto" : "-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8 min-w-full"}>
          <div className={props.embedded ? "inline-block min-w-full py-2 align-middle" : "inline-block min-w-full py-2 align-middle md:px-6 lg:px-8"}>
            <div className="overflow-hidden">
              <table className="min-w-full divide-y divide-slate-200">
                <thead>
                  <tr>
                    <th
                      scope="col"
                      className="w-[24%] py-3.5 pl-6 pr-3 text-left text-xs text-slate-500 font-medium"
                    >
                      Locations
                    </th>
                    <th
                      scope="col"
                      className="flex-1 px-3 py-3.5 text-left text-xs text-slate-500 font-medium"
                    >
                      Standard Hours
                    </th>
                    <th
                      scope="col"
                      className="flex-1 px-3 py-3.5 text-left text-xs text-slate-500 font-medium"
                    >
                      Special Hours / Overrides
                    </th>
                    <th
                      scope="col"
                      className="w-1/12 relative py-3.5 pl-3 pr-6"
                    >
                      {/* <span className="sr-only">Edit</span> */}
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-200 bg-white">
                  {props.hoursOfOperation?.map((location, i) => (
                    <HoursOfOperationTableRow
                      key={i}
                      i={i}
                      canCheckPublishedHours={props.canCheckPublishedHours}
                      onHoursVerified={props.onHoursVerified}
                      isSavingData={props.isSavingData}
                      location={location}
                      update_hours_for_all_stores={
                        props.update_hours_for_all_stores
                      }
                      storeNames={props.storeNames}
                    />
                  ))}
                </tbody>
              </table>
              <div className="border-b border-slate-200"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HoursOfOperationDisplay;
